import { useNavigate, type NavigateFunction } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function NotFoundPage(): React.JSX.Element {
  const navigate: NavigateFunction = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[60vh] text-center px-4">
      <div className="text-8xl font-bold text-primary/20 mb-4">404</div>
      <h1 className="text-2xl font-semibold text-foreground mb-2">
        Seite nicht gefunden
      </h1>
      <p className="text-sm text-muted-foreground mb-8 max-w-md">
        Die angeforderte Seite existiert nicht oder wurde verschoben.
        Bitte überprüfe die URL oder kehre zum Dashboard zurück.
      </p>
      <button
        onClick={() => {
          void navigate('/');
        }}
        className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-primary-foreground
                   bg-primary rounded-lg hover:bg-primary/90
                   transition-colors duration-[var(--transition-fast)] focus-ring"
      >
        <ArrowLeft size={16} />
        Zurück zum Dashboard
      </button>
    </div>
  );
}
